import { Component } from '@angular/core';

import { Translations } from '../shared/translations';
import { I18nSelectPipe } from '@angular/common';

@Component({
  selector: 'imprint',
  templateUrl: 'imprint.component.html',
  styleUrls: ['imprint.component.scss'],
  imports: [I18nSelectPipe]
})
export class ImprintComponent {
  translations = Translations;
}
